import './LoaderMoviePage.scss'

export const LoaderMoviePage = () => {

    return (
        <div className='skeleton-movie'>
            <div className="skeleton-movie__wrap">
         <span className="skeleton-movie__string skeleton-movie__string_title"></span>
            <span className="skeleton-movie__string skeleton-movie__string_dscr"></span>
            <div className="skeleton-movie__block">
            <span className="skeleton-movie__string skeleton-movie__string_btn"></span>
            <span className="skeleton-movie__string skeleton-movie__string_btn"></span>
            </div>
            
            </div>
   
            <span className='skeleton-movie__img'></span>

        </div>

    )
}

